<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmSendMonthlyReport
			v-if="isOpenModal && modalType === modalTypes.CREATE"
			@close="closeModal"
			@submit="sendReport"
			:name="sendData?.order"
		/>
		<SendData
			v-if="type === 'send'"
			v-model:data="dataProps"
			@close="closeModal"
			@success="success"
		/>
		<DeleteConfirmModal
			v-if="type === 'delete'"
			v-model:data="dataProps"
			@close="closeModal"
			@success="success"
		/>
	</DaModalFrame>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			v-if="sideOverShow"
			@click="sideOverShow = false"
		></div>
		<SideOver
			@close="sideOverShow = false"
			@submit="filterSubmit($event)"
			@cancel="filterSubmit($event)"
			@isFilterDate="isFilterDate = true"
			:staffs="staffs"
			:students="students"
			:isAdmin="isAdmin"
			:isOpen="sideOverShow"
		/>
	</div>
	<div>
		<div v-if="!isLoading">
			<div class="mb-10" v-if="alertShow">
				<div
					class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
				>
					<div class="relative">
						<div class="flex items-center gap-4">
							<div>
								<img
									src="@/assets/images/logo/logo.svg"
									alt="luca-logo"
									height="24"
									width="35"
								/>
							</div>
							<div class="pt-1 text-neutral-600 text-sm">
								Dùng nền tảng ứng dụng di động tải về từ
								<a
									href="https://onelink.to/p88838"
									class="underline text-green-500 font-medium"
									>App Store/ CH Play</a
								>
								để tạo và chỉnh sửa báo cáo buổi học
							</div>
						</div>
						<div
							class="top-1 right-2 absolute cursor-pointer"
							@click="alertShow = false"
						>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
									fill="#E5A42B"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div
				class="__report-lesson__container"
				:class="isAdmin ? 'mt-8' : ''"
				v-if="reports && reports.length > 0"
			>
				<div class="mb-8">
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.state === 'completed'"
					>
						Báo cáo đã hoàn thành
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ state: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.state === 'incompleted'"
					>
						Báo cáo chưa nộp
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ state: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.state === 'cancelled'"
					>
						Báo cáo đã huỷ
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ state: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.date && isFilterDate"
					>
						<span v-if="filter.toDate"
							>Từ
							{{ $filters.formatDate2(filter.toDate) }} đến</span
						><span class="ml-1">{{
							$filters.formatDate2(filter.date)
						}}</span>
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ date: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2"
						v-if="filter?.student_id"
					>
						{{
							studentById(filter.student_id)
								? studentById(filter.student_id).name
								: ''
						}}
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ student_id: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.staff_id"
					>
						{{
							staffById(filter.staff_id)
								? staffById(filter.staff_id).name
								: ''
						}}
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900 shadow-input"
							@click="filterSubmit({ staff_id: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="inline-flex items-center py-0.5 rounded-full ml-2 font-semibold cursor-pointer text-sm text-neutral-500 hover:text-neutral-700"
						v-if="
							filter &&
							Object.keys(filter).length >= 0 &&
							isFilterDate
						"
						@click="filterSubmit(null)"
					>
						Xoá hết bộ lọc
					</span>
				</div>
				<div v-for="report in reports" :key="report.date" class="mb-10">
					<div class="relative mb-3">
						<div
							class="absolute inset-0 flex items-center"
							aria-hidden="true"
						>
							<div
								class="w-full border-t border-gray-300 mb-3.5"
							/>
						</div>
						<div class="relative flex justify-between">
							<div
								class="font-bold text-neutral-600 text-lg mb-3 bg-body pr-3"
							>
								{{ $filters.formatDate2(report.date) }}
							</div>
							<div
								class="bg-body pl-3"
								@click="showHide(report.date)"
							>
								<button
									type="button"
									class="cursor-pointer button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
								>
									<div
										class="mr-1 transform"
										:class="{
											'rotate-180': isHides.includes(
												report.date
											),
										}"
									>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M15 12.5L10 7.5L5 12.5"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</div>
									<span>{{
										isHides.includes(report.date)
											? 'Mở rộng'
											: 'Thu gọn'
									}}</span>
								</button>
							</div>
						</div>
					</div>
					<div
						class="grid gap-8 md-down:gap-4 mb-10 md-down:grid-cols-1 grid-cols-3"
						:class="{
							'grid-cols-2': filter?.state === 'cancelled',
							'grid-cols-3': isLitePackage && isAdmin,
							'grid-cols-4': !isLitePackage && isAdmin ,
							
						}"
					>
						<div
							class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="21"
									height="20"
									viewBox="0 0 21 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clip-path="url(#clip0_1704:5240)">
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M1.66797 1.66667C1.66797 0.746192 2.40767 0 3.32014 0H16.5375C17.45 0 18.1897 0.746192 18.1897 1.66667V8.81793C17.4244 8.50542 16.5878 8.33333 15.7114 8.33333C12.0616 8.33333 9.10275 11.25 9.10275 14.9319C9.10275 16.9231 9.96809 18.7784 11.3401 20H3.32014C2.40767 20 1.66797 19.2538 1.66797 18.3333V1.66667ZM2.9071 7.5C2.9071 7.26988 3.09203 7.08333 3.32014 7.08333H11.168C11.3961 7.08333 11.581 7.26988 11.581 7.5C11.581 7.73012 11.3961 7.91667 11.168 7.91667H3.32014C3.09203 7.91667 2.9071 7.73012 2.9071 7.5ZM2.9071 10C2.9071 9.76988 3.09203 9.58333 3.32014 9.58333H9.51579C9.74391 9.58333 9.92884 9.76988 9.92884 10C9.92884 10.2301 9.74391 10.4167 9.51579 10.4167H3.32014C3.09203 10.4167 2.9071 10.2301 2.9071 10ZM2.9071 12.5C2.9071 12.2699 3.09203 12.0833 3.32014 12.0833H7.86362C8.09174 12.0833 8.27666 12.2699 8.27666 12.5C8.27666 12.7301 8.09174 12.9167 7.86362 12.9167H3.32014C3.09203 12.9167 2.9071 12.7301 2.9071 12.5ZM2.9071 15C2.9071 14.7699 3.09203 14.5833 3.32014 14.5833H6.21145C6.43956 14.5833 6.62449 14.7699 6.62449 15C6.62449 15.2301 6.43956 15.4167 6.21145 15.4167H3.32014C3.09203 15.4167 2.9071 15.2301 2.9071 15ZM2.9071 3.75C2.9071 3.28976 3.27695 2.91667 3.73319 2.91667H14.8854C15.3416 2.91667 15.7114 3.28976 15.7114 3.75C15.7114 4.21024 15.3416 4.58333 14.8854 4.58333H3.73319C3.27695 4.58333 2.9071 4.21024 2.9071 3.75Z"
											fill="#2AA797"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M15.7114 20C18.4489 20 20.668 17.7614 20.668 15C20.668 12.2386 18.4489 10 15.7114 10C12.974 10 10.7549 12.2386 10.7549 15C10.7549 17.7614 12.974 20 15.7114 20ZM17.5514 13.106C17.7328 12.923 18.027 12.923 18.2085 13.106C18.3877 13.2869 18.3899 13.5786 18.2151 13.7622L15.7417 16.8811C15.7381 16.8856 15.7343 16.8899 15.7302 16.894C15.5488 17.077 15.2546 17.077 15.0731 16.894L13.4334 15.2399C13.252 15.0569 13.252 14.7601 13.4334 14.577C13.6149 14.394 13.9091 14.394 14.0906 14.577L15.3877 15.8855L17.539 13.1201C17.5429 13.1151 17.547 13.1105 17.5514 13.106Z"
											fill="#2AA797"
										/>
									</g>
									<defs>
										<clipPath id="clip0_1704:5240">
											<rect
												width="20"
												height="20"
												fill="white"
												transform="translate(0.667969)"
											/>
										</clipPath>
									</defs>
								</svg>
								<div class="text-neutral-500 text-sm ml-2">
									Báo cáo hoàn thành
								</div>
							</div>
							<div
								class="flex items-center flex-nowrap justify-between"
							>
								<div
									class="text-neutral-600 font-bold text-4xl"
								>
									{{
										filter?.state === 'cancelled'
											? cancelData[report.date]
													?.completed_count
											: statsData[report.date]
													?.completed_count
									}}/{{
										filter?.state === 'cancelled'
											? cancelData[report.date]?.total
											: statsData[report.date]?.total
									}}
								</div>
							</div>
						</div>
						<div
							class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="21"
									height="20"
									viewBox="0 0 21 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clip-path="url(#clip0_1704:5253)">
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z"
											fill="#94A3B8"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z"
											fill="#94A3B8"
										/>
									</g>
									<defs>
										<clipPath id="clip0_1704:5253">
											<rect
												width="20"
												height="20"
												fill="white"
												transform="translate(0.332031)"
											/>
										</clipPath>
									</defs>
								</svg>
								<div class="text-neutral-500 text-sm ml-2">
									Báo cáo chưa hoàn thành
								</div>
							</div>
							<div
								class="flex items-center flex-nowrap justify-between"
							>
								<div
									class="text-neutral-600 font-bold text-4xl"
								>
									{{
										filter?.state === 'cancelled'
											? cancelData[report.date]
													?.incomplete_count
											: statsData[report.date]
													?.incomplete_count
									}}
								</div>
							</div>
						</div>

						<div
							class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
							v-if="filter?.state !== 'cancelled'"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M2.4987 0C1.57822 0 0.832031 0.746192 0.832031 1.66667V18.3333C0.832031 19.2538 1.57822 20 2.4987 20H10.589C9.20496 18.7784 8.33203 16.9231 8.33203 14.9319C8.33203 11.25 11.3168 8.33333 14.9987 8.33333C15.8828 8.33333 16.7267 8.50542 17.4987 8.81793V1.66667C17.4987 0.746192 16.7525 0 15.832 0H2.4987ZM2.4987 7.08333C2.26858 7.08333 2.08203 7.26988 2.08203 7.5C2.08203 7.73012 2.26858 7.91667 2.4987 7.91667H10.4154C10.6455 7.91667 10.832 7.73012 10.832 7.5C10.832 7.26988 10.6455 7.08333 10.4154 7.08333H2.4987ZM2.4987 9.58333C2.26858 9.58333 2.08203 9.76988 2.08203 10C2.08203 10.2301 2.26858 10.4167 2.4987 10.4167H8.7487C8.97882 10.4167 9.16536 10.2301 9.16536 10C9.16536 9.76988 8.97882 9.58333 8.7487 9.58333H2.4987ZM2.4987 12.0833C2.26858 12.0833 2.08203 12.2699 2.08203 12.5C2.08203 12.7301 2.26858 12.9167 2.4987 12.9167H7.08203C7.31215 12.9167 7.4987 12.7301 7.4987 12.5C7.4987 12.2699 7.31215 12.0833 7.08203 12.0833H2.4987ZM2.4987 14.5833C2.26858 14.5833 2.08203 14.7699 2.08203 15C2.08203 15.2301 2.26858 15.4167 2.4987 15.4167H5.41536C5.64548 15.4167 5.83203 15.2301 5.83203 15C5.83203 14.7699 5.64548 14.5833 5.41536 14.5833H2.4987ZM2.91536 2.91667C2.45513 2.91667 2.08203 3.28976 2.08203 3.75C2.08203 4.21024 2.45513 4.58333 2.91536 4.58333H14.1654C14.6256 4.58333 14.9987 4.21024 14.9987 3.75C14.9987 3.28976 14.6256 2.91667 14.1654 2.91667H2.91536Z"
										fill="#E37056"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M19.9987 15C19.9987 17.7614 17.7601 20 14.9987 20C12.2373 20 9.9987 17.7614 9.9987 15C9.9987 12.2386 12.2373 10 14.9987 10C17.7601 10 19.9987 12.2386 19.9987 15ZM13.3447 12.904C13.2226 12.782 13.0248 12.782 12.9027 12.904C12.7807 13.0261 12.7807 13.2239 12.9027 13.346L14.5568 15L12.9027 16.654C12.7807 16.7761 12.7807 16.9739 12.9027 17.096C13.0248 17.218 13.2226 17.218 13.3447 17.096L14.9987 15.4419L16.6527 17.096C16.7748 17.218 16.9726 17.218 17.0947 17.096C17.2167 16.9739 17.2167 16.7761 17.0947 16.654L15.4406 15L17.0947 13.346C17.2167 13.2239 17.2167 13.0261 17.0947 12.904C16.9726 12.782 16.7748 12.782 16.6527 12.904L14.9987 14.5581L13.3447 12.904Z"
										fill="#E37056"
									/>
								</svg>

								<div class="text-neutral-500 text-sm ml-2">
									Báo cáo đã huỷ
								</div>
							</div>
							<div
								class="flex items-center flex-nowrap justify-between"
							>
								<div
									class="text-neutral-600 font-bold text-4xl"
								>
									{{ statsData[report.date]?.cancelled || 0 }}
								</div>
							</div>
						</div>
						<div
							v-if="filter?.state !== 'cancelled' && !isLitePackage"
							class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="21"
									height="20"
									viewBox="0 0 21 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M13.1978 10.0001C13.1978 11.5821 11.9152 12.8647 10.3332 12.8647C8.7511 12.8647 7.46859 11.5821 7.46859 10.0001C7.46859 8.41802 8.7511 7.1355 10.3332 7.1355C11.9152 7.1355 13.1978 8.41802 13.1978 10.0001Z"
										fill="#2AA797"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M1.1665 10.0001C1.1665 10.0001 4.604 3.698 10.3332 3.698C16.0623 3.698 19.4998 10.0001 19.4998 10.0001C19.4998 10.0001 16.0623 16.3022 10.3332 16.3022C4.604 16.3022 1.1665 10.0001 1.1665 10.0001ZM10.3332 14.0105C12.5481 14.0105 14.3436 12.215 14.3436 10.0001C14.3436 7.78519 12.5481 5.98966 10.3332 5.98966C8.11828 5.98966 6.32275 7.78519 6.32275 10.0001C6.32275 12.215 8.11828 14.0105 10.3332 14.0105Z"
										fill="#2AA797"
									/>
								</svg>
								<div class="text-neutral-500 text-sm ml-2">
									PH đã xem
								</div>
							</div>
							<div
								class="flex items-center flex-nowrap justify-between"
							>
								<div
									class="text-neutral-600 font-bold text-4xl"
								>
									{{
										statsData[report.date]
											?.number_of_parent_read_count || 0
									}}
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="!isHides.includes(report.date)"
						class="mb-10 shadow-sm sm:rounded-2xl"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<table
								class="lesson-report-table divide-y text-neutral-200 rounded-2xl"
							>
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											scope="col"
											class="col-stt px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider"
										>
											STT
										</th>
										<th
											scope="col"
											class="col-student px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Tên học sinh
										</th>
										<th
											v-if="org.enable_report_by_session"
											scope="col"
											class="col-session px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
										>
											Giờ học
										</th>
										<th
											scope="col"
											class="col-status px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
										>
											Trạng Thái
										</th>
										<th
											scope="col"
											class="col-goal px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
										>
											Mục tiêu
										</th>
										<th
											scope="col"
											class="col-emotion px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
										>
											Cảm xúc
										</th>
										<th
											v-if="!isLitePackage"
											scope="col"
											class="col-album px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											ALBUM
										</th>
										<th
											scope="col"
											class="col-participation px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
										>
											Mức độ tham gia
										</th>
										<th
											scope="col"
											class="col-teacher px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											{{
												$filters.terminology(
													'teacher_short_name'
												)
											}}
										</th>
										<th
											scope="col"
											class="col-attendance px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
										>
											Điểm danh
										</th>
										<th
											scope="col"
											v-if="!isLitePackage"
											class="col-parent-read px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
										>
											PH ĐÃ XEM
										</th>
										<th
											scope="col"
											class="col-action px-3 py-3 tracking-wider whitespace-nowrap"
										></th>
									</tr>
								</thead>
								<tbody>
									<tr
										@click.prevent="
											!['new', 'created'].includes(
												item.state
											) &&
												$router.push(
													`/report/lesson/${item.date}?student_id=${item?.student?.id}`
												)
										"
										v-for="(item, index) in report.data"
										:key="item.id"
										:class="[
											index % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50',
											!['new', 'created'].includes(
												item.state
											)
												? 'cursor-pointer hover:bg-orange-50'
												: '',
										]"
										class="text-neutral-700"
									>
										<td>
											<div
												class="px-3 py-4 text-center text-neutral-700"
											>
												{{ index + 1 }}
											</div>
										</td>
										<td
											class="col-student px-3 py-4 text-neutral-700"
										>
											<div
												class="flex items-center cursor-pointer min-w-0"
											>
												<img
													class="shadow-sm inline-block h-6 w-6 rounded-full flex-shrink-0"
													:src="
														item?.student
															?.profile_photo
															?.w200
													"
													v-if="
														item?.student
															?.profile_photo
															?.w200
													"
													alt=""
												/>
												<span
													v-else
													class="inline-flex items-center justify-center h-6 w-6 rounded-full flex-shrink-0"
													:style="{
														background:
															item?.student
																?.profile_photo
																?.default
																?.color,
													}"
												>
													<span
														class="text-xs font-medium leading-none text-white"
														>{{
															item?.student
																?.profile_photo
																?.default
																?.initial
														}}</span
													>
												</span>
												<div
													class="ml-2 font-semibold text-orange-600 flex-1 min-w-0 whitespace-nowrap"
												>
													{{ item?.student?.name }}
												</div>
											</div>
										</td>
										<td v-if="org.enable_report_by_session">
											<div
												v-if="item?.session"
												class="px-3 py-4"
											>
												<span
													v-if="
														item?.session
															?.display_start_slot
													"
													>{{
														item?.session
															?.display_start_slot
													}}</span
												>
												<span
													v-if="
														item?.session
															?.display_end_slot
													"
													>-
													{{
														item?.session
															?.display_end_slot
													}}</span
												>
											</div>
										</td>
										<td class="px-3 py-4 text-neutral-700">
											<div class="flex justify-center">
												<svg
													width="21"
													height="20"
													viewBox="0 0 21 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													v-if="
														item.state ===
														'completed'
													"
												>
													<g
														clip-path="url(#clip0_1706:5649)"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M1.5 1.66667C1.5 0.746192 2.2397 0 3.15217 0H16.3696C17.282 0 18.0217 0.746192 18.0217 1.66667V8.81793C17.2564 8.50542 16.4199 8.33333 15.5435 8.33333C11.8936 8.33333 8.93478 11.25 8.93478 14.9319C8.93478 16.9231 9.80012 18.7784 11.1721 20H3.15217C2.2397 20 1.5 19.2538 1.5 18.3333V1.66667ZM2.73913 7.5C2.73913 7.26988 2.92406 7.08333 3.15217 7.08333H11C11.2281 7.08333 11.413 7.26988 11.413 7.5C11.413 7.73012 11.2281 7.91667 11 7.91667H3.15217C2.92406 7.91667 2.73913 7.73012 2.73913 7.5ZM2.73913 10C2.73913 9.76988 2.92406 9.58333 3.15217 9.58333H9.34783C9.57594 9.58333 9.76087 9.76988 9.76087 10C9.76087 10.2301 9.57594 10.4167 9.34783 10.4167H3.15217C2.92406 10.4167 2.73913 10.2301 2.73913 10ZM2.73913 12.5C2.73913 12.2699 2.92406 12.0833 3.15217 12.0833H7.69565C7.92377 12.0833 8.1087 12.2699 8.1087 12.5C8.1087 12.7301 7.92377 12.9167 7.69565 12.9167H3.15217C2.92406 12.9167 2.73913 12.7301 2.73913 12.5ZM2.73913 15C2.73913 14.7699 2.92406 14.5833 3.15217 14.5833H6.04348C6.2716 14.5833 6.45652 14.7699 6.45652 15C6.45652 15.2301 6.2716 15.4167 6.04348 15.4167H3.15217C2.92406 15.4167 2.73913 15.2301 2.73913 15ZM2.73913 3.75C2.73913 3.28976 3.10898 2.91667 3.56522 2.91667H14.7174C15.1736 2.91667 15.5435 3.28976 15.5435 3.75C15.5435 4.21024 15.1736 4.58333 14.7174 4.58333H3.56522C3.10898 4.58333 2.73913 4.21024 2.73913 3.75Z"
															fill="#2AA797"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M15.5435 20C18.2809 20 20.5 17.7614 20.5 15C20.5 12.2386 18.2809 10 15.5435 10C12.8061 10 10.587 12.2386 10.587 15C10.587 17.7614 12.8061 20 15.5435 20ZM17.3834 13.106C17.5649 12.923 17.8591 12.923 18.0405 13.106C18.2198 13.2869 18.222 13.5786 18.0471 13.7622L15.5737 16.8811C15.5701 16.8856 15.5663 16.8899 15.5623 16.894C15.3808 17.077 15.0866 17.077 14.9051 16.894L13.2655 15.2399C13.084 15.0569 13.084 14.7601 13.2655 14.577C13.4469 14.394 13.7412 14.394 13.9226 14.577L15.2197 15.8855L17.3711 13.1201C17.3749 13.1151 17.379 13.1105 17.3834 13.106Z"
															fill="#2AA797"
														/>
													</g>
													<defs>
														<clipPath
															id="clip0_1706:5649"
														>
															<rect
																width="20"
																height="20"
																fill="white"
																transform="translate(0.5)"
															/>
														</clipPath>
													</defs>
												</svg>
												<svg
													width="21"
													height="20"
													viewBox="0 0 21 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													v-else-if="
														item.state ===
															'cancelled' ||
														item.state === 'deleted'
													"
												>
													<g
														clip-path="url(#clip0_1739:6086)"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z"
															fill="#E37056"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z"
															fill="#E37056"
														/>
													</g>
													<defs>
														<clipPath
															id="clip0_1739:6086"
														>
															<rect
																width="20"
																height="20"
																fill="white"
																transform="translate(0.5)"
															/>
														</clipPath>
													</defs>
												</svg>
												<svg
													width="21"
													height="20"
													viewBox="0 0 21 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													v-else
												>
													<g
														clip-path="url(#clip0_1739:6086)"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z"
															fill="#94A3B8"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z"
															fill="#94A3B8"
														/>
													</g>
													<defs>
														<clipPath
															id="clip0_1739:6086"
														>
															<rect
																width="20"
																height="20"
																fill="white"
																transform="translate(0.5)"
															/>
														</clipPath>
													</defs>
												</svg>
											</div>
										</td>
										<td>
											<div
												class="px-3 py-4"
												style="max-width: 140px"
											>
												{{ item?.assessment_count }}/{{
													item?.goal_of_plan_count
												}}
											</div>
										</td>
										<td>
											<div class="px-3 py-4">
												<img
													v-if="item?.emotion_scale"
													:src="
														require(`@/assets/images/emoji/${
															$filters.emoji(
																item?.emotion_scale +
																	''
															).emoji
														}`)
													"
													alt=""
													class="h-6 w-6"
												/>
											</div>
										</td>
										<td
											v-if="!isLitePackage"
											class="whitespace-nowrap text-neutral-700"
										>
											<div
												class="pl-5 py-4"
												v-if="
													item.goal_media &&
													item.goal_media.length
												"
											>
												<svg
													width="20"
													height="20"
													viewBox="0 0 20 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z"
														fill="#E5A42B"
													/>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
														fill="#E5A42B"
													/>
												</svg>
											</div>
										</td>
										<td>
											<div
												class="px-3 py-4"
												style="max-width: 140px"
											>
												<Rating
													:rating="
														item?.cooperation_scale
													"
												/>
											</div>
										</td>
										<td
											class="col-teacher px-3 py-4 text-neutral-700"
										>
											<div
												v-if="
													item?.session?.staffs
														.length > 0
												"
												class="flex flex-col gap-3 min-w-0"
											>
												<div
													v-for="staff in item
														?.session?.staffs"
													:key="staff.id"
												>
													<div
														@click.stop="
															$router.push(
																`/record/employee/${staff.id}`
															)
														"
														class="flex items-center cursor-pointer min-w-0 teacher gap-2"
													>
														<div
															class="inline-flex items-center justify-center h-6 w-6 rounded-full relative flex-shrink-0"
															:style="{
																background:
																	staff
																		?.profile_photo
																		?.default
																		?.color,
															}"
														>
															<span
																class="text-xs font-medium leading-none text-white"
																>{{
																	staff
																		?.profile_photo
																		?.default
																		?.initial
																}}</span
															>
															<div
																v-if="
																	staff.id ===
																	item
																		?.submitted_by_staff
																		?.id
																"
																class="submit flex items-center justify-center"
															>
																<img
																	class="w-3 h-3"
																	src="@/assets/images/icons/white-send.png"
																	alt=""
																/>
															</div>
														</div>
														<div
															class="teacher__name font-semibold text-blue-600 flex-1 min-w-0 whitespace-nowrap"
														>
															{{ staff?.name }}
														</div>
													</div>
												</div>
											</div>
											<div v-else>
												<div
													@click.stop="
														$router.push(
															`/record/employee/${item?.submitted_by_staff?.id}`
														)
													"
													class="flex items-center cursor-pointer min-w-0 teacher"
													v-if="
														item?.submitted_by_staff
													"
												>
													<span
														class="inline-flex items-center justify-center h-6 w-6 rounded-full flex-shrink-0"
														:style="{
															background:
																item
																	?.submitted_by_staff
																	?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="text-xs font-medium leading-none text-white"
															>{{
																item
																	?.submitted_by_staff
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
													<div
														class="ml-2 teacher__name font-semibold text-blue-600 flex-1 min-w-0 whitespace-nowrap"
													>
														{{
															item
																?.submitted_by_staff
																?.name
														}}
													</div>
												</div>
											</div>
										</td>
										<td
											class="px-3 py-4 capitalize whitespace-nowrap"
										>
											<div
												class="flex items-center gap-2"
											>
												<img
													v-if="
														item?.checkin
															?.display_media_timestamp ||
														item?.checkin
															?.display_time
													"
													src="@/assets/images/icons/checkin.png"
													alt=""
												/>
												<img
													v-else
													src="@/assets/images/icons/disabled-checkin.png"
													alt=""
												/>
												<div
													v-if="
														item?.checkin
															?.display_media_timestamp ||
														item?.checkin
															?.display_time
													"
												>
													{{
														item?.checkin
															?.display_media_timestamp ||
														item?.checkin
															?.display_time
													}}
												</div>
												<div v-else>-</div>
												<img
													v-if="
														item?.checkin?.sent_at
													"
													src="@/assets/images/icons/has_taught.png"
													alt=""
												/>
											</div>
											<div
												class="flex items-center gap-2"
											>
												<img
													v-if="
														item?.checkout
															?.display_media_timestamp ||
														item?.checkout
															?.display_time
													"
													src="@/assets/images/icons/checkout.png"
													alt=""
												/>
												<img
													v-else
													src="@/assets/images/icons/disabled-checkout.png"
													alt=""
												/>
												<div
													v-if="
														item?.checkout
															?.display_media_timestamp ||
														item?.checkout
															?.display_time
													"
												>
													{{
														item?.checkout
															?.display_media_timestamp ||
														item?.checkout
															?.display_time
													}}
												</div>
												<div v-else>-</div>
												<img
													v-if="
														item?.checkout?.sent_at
													"
													src="@/assets/images/icons/has_taught.png"
													alt=""
												/>
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700"
											v-if="!isLitePackage"
										>
											<button
												v-if="
													item.state ===
														'completed' &&
													!item.sent_at &&
													!org?.enable_lesson_report_sent
												"
												@click.stop="sendReport(item)"
												type="button"
												class="button-p text-center whitespace-nowrap w-fit btn--ghost"
											>
												Gửi
											</button>
											<div
												v-else-if="item.sent_at"
												class="px-3 py-4 capitalize whitespace-nowrap"
											>
												{{
													item.numbers_of_parent_read
												}}/
												{{ item.total_parent_count }}
											</div>
											<div v-else>-</div>
										</td>
										<td>
											<Menu
												v-if="
													isAdmin ||
													(((item?.checkin &&
														!item?.checkin
															.sent_at) ||
														(item?.checkout &&
															!item?.checkout
																?.sent_at)) &&
														flagCheck() &&
														enableStaffSendAttendanceTrack)
												"
												as="div"
												class="px-3 relative"
											>
												<div>
													<MenuButton
														@click.stop="() => {}"
														class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
													>
														<span class="sr-only"
															>Open user
															menu</span
														>
														<svg
															width="20"
															height="20"
															viewBox="0 0 20 20"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
																fill="#94A3B8"
															/>
														</svg>
													</MenuButton>
												</div>
												<transition
													enter-active-class="transition ease-out duration-200"
													enter-from-class="transform opacity-0 scale-95"
													enter-to-class="transform opacity-100 scale-100"
													leave-active-class="transition ease-in duration-75"
													leave-from-class="transform opacity-100 scale-100"
													leave-to-class="transform opacity-0 scale-95"
												>
													<MenuItems
														class="origin-top-right absolute right-0 mt-2 w-80 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm"
													>
														<MenuItem
															v-if="
																((item?.checkin &&
																	!item
																		?.checkin
																		.sent_at) ||
																	(item?.checkout &&
																		!item
																			?.checkout
																			?.sent_at)) &&
																flagCheck() &&
																enableStaffSendAttendanceTrack
															"
														>
															<div
																class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																@click.stop="
																	openSendData(
																		item
																	)
																"
															>
																<img
																	src="@/assets/images/icons/send.png"
																	alt=""
																/>
																<div>
																	Gửi điểm
																	danh tới PH
																</div>
															</div>
														</MenuItem>
														<MenuItem
															v-if="isAdmin"
														>
															<div
																v-if="
																	filter?.state !==
																	'cancelled'
																"
																@click.stop="
																	openDeleteConfirm(
																		item
																	)
																"
																class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
															>
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
																		fill="#94A3B8"
																	/>
																</svg>
																<div>
																	Xoá báo cáo
																</div>
															</div>
															<div
																v-else
																@click.stop="
																	recoverReport(
																		item.id
																	)
																"
																class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
															>
																<svg
																	width="16"
																	height="12"
																	viewBox="0 0 16 12"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		d="M11.5356 5H15.4681C15.6801 5 15.7959 5.24721 15.6602 5.41005L13.6939 7.76953C13.594 7.88947 13.4098 7.88947 13.3098 7.76953L11.3436 5.41005C11.2079 5.24721 11.3237 5 11.5356 5Z"
																		fill="#94A3B8"
																	/>
																	<path
																		d="M0.535634 7H4.46811C4.68007 7 4.79586 6.75279 4.66017 6.58995L2.69393 4.23047C2.59398 4.11053 2.40977 4.11053 2.30982 4.23047L0.343579 6.58995C0.207886 6.75279 0.323675 7 0.535634 7Z"
																		fill="#94A3B8"
																	/>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M8.00188 1C6.44938 1 5.06244 1.70697 4.14456 2.81839C3.96872 3.03131 3.65357 3.06137 3.44065 2.88552C3.22773 2.70968 3.19767 2.39453 3.37351 2.18161C4.47322 0.850027 6.13849 0 8.00188 0C10.9436 0 13.3899 2.1165 13.903 4.90967C13.9085 4.9397 13.9138 4.96981 13.9188 5H12.902C12.4389 2.71778 10.4205 1 8.00188 1ZM3.10179 7C3.5648 9.28222 5.58325 11 8.00188 11C9.55437 11 10.9413 10.293 11.8592 9.18161C12.035 8.96869 12.3502 8.93863 12.5631 9.11448C12.776 9.29032 12.8061 9.60547 12.6302 9.81839C11.5305 11.15 9.86526 12 8.00188 12C5.06017 12 2.61385 9.8835 2.10079 7.09033C2.09527 7.0603 2.08998 7.03019 2.08491 7H3.10179Z"
																		fill="#94A3B8"
																	/>
																</svg>

																<div>
																	Khôi phục
																	báo cáo
																</div>
															</div>
														</MenuItem>
													</MenuItems>
												</transition>
											</Menu>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<DaInfinityLoading
					@infinite-load="getLessonList"
					:loaded="stopLoad"
					v-if="isInfinityLoading"
					:is-loading="isFetching"
				/>
			</div>
			<div
				v-else
				class="w-full h-full flex items-center justify-center flex-col mt-20"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div class="text-neutral-500 text-lg max-w-lg text-center">
					Cơ sở chưa có báo cáo cá nhân nào. Dùng app
					{{ $filters.terminology('teacher') }} để báo cáo kết quả học
					cá nhân hàng ngày của học sinh.
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import Rating from '@/components/elements/rating/Rating.vue';
import { useStats } from '@/features/lessonReport/stats';
import { Options, Vue, setup } from 'vue-class-component';
import { useListLessonReport } from '@/features/lessonReport/listLessonReport';
import { Watch } from 'vue-property-decorator';
import SideOver from '@/components/elements/sideOver/SideOver.vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import DaInfinityLoading from '@/components/common/daInfinityLoading/DaInfinityLoading.vue';
import { useGetEmployees } from '@/views/record/employee/services/getEmployees';
import { useStudent } from '@/features/student/useStudent';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import Loading from '@/components/common/Loading.vue';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import DeleteConfirmModal from './DeleteConfirm.vue';
import SendData from './SendData.vue';
import ConfirmSendMonthlyReport from '@/views/report/features/monthlyReport/features/ConfirmSendMonthlyReport/ConfirmSendMonthlyReport.vue';
import { $api } from '@/services';
import { FLAG_CHECK } from '@/helper/flagCheck';
import { isLitePackage } from '@/helper/packageTier';
import store from '@/store';
@Options({
	name: 'ReportLesson',
	components: {
		ConfirmSendMonthlyReport,
		DeleteConfirmModal,
		DaModalFrame,
		Loading,
		DaInfinityLoading,
		SideOver,
		Rating,
		DaIcon,
		Menu,
		MenuButton,
		MenuItem,
		MenuItems,
		SendData,
	},
	props: {
		openFilter: {
			type: Number,
			default: 0,
		},
	},
})
export default class ReportLesson extends Vue {
	sideOverShow = false;
	statsData = [];
	cancelData = [];
	filter = null;
	LessonReports = [];
	dateNow = new Date();
	date = '';
	afterId = null;
	before = '';
	isFilterDate = false;
	stopLoad = false;
	staffs = [];
	students = [];
	filterOptionsLoaded = false;
	filterOptionsLoading = false;
	isInfinityLoading = true;
	isLoading = true;
	isFetching = false;
	listRequestId = 0;
	alertShow = true;
	modalIsOpen = false;
	dataProps = null;
	isHides = [];
	type = '';

	@Watch('openFilter')
	onOpenFilter(val) {
		if (val) {
			this.sideOverShow = true;
			this.loadFilterOptions();
		}
	}

	//----------------------- 🤍 Setup 🤍 -----------------------//
	setup = setup(() => {
		const store = useStore();
		const { error, loading, stats } = useStats();
		const { getSimpleStudents } = useStudent();
		const { getSimpleStaffs } = useGetEmployees();
		const { listLessonReport } = useListLessonReport();
		return {
			getSimpleStaffs,
			getSimpleStudents,
			error,
			loading,
			stats,
			listLessonReport,
			store,
		};
	});

	//----------------------- 🤍 Getter 🤍 -----------------------//
	get lessonReports() {
		return this.LessonReports;
	}

	get enableStaffSendAttendanceTrack() {
		return this.setup.store.state.profile.current_org
			.enable_staff_send_attendance_track;
	}

	get enablePersonalSchedule() {
		return this.setup.store.state.profile.current_org
			.enable_personal_schedule;
	}

	get reports() {
		const g = this.groups(this.lessonReports);
		const rs = Object.keys(g).map((date) => {
			return {
				date,
				data: g[date],
			};
		});
		return rs;
	}

	get isAdmin() {
		return this.setup.store.getters.isAdmin;
	}

	get org() {
		return this.setup.store.state.profile.current_org;
	}

	get store() {
		return this.setup.store;
	}

	get isLitePackage() {
		return isLitePackage(store.state.profile);
	}

	//----------------------- 🤍 Created 🤍 -----------------------//
	created() {
		const q = this.$route.query;
		this.date = q.date ? dayjs(q.date).format('DD/MM/YYYY') : '';
		if (q?.date) {
			this.filter = {
				date: q?.date,
				toDate: q?.toDate,
			};
			this.isFilterDate = !!q?.date;
			this.before = dayjs(q.date).add(1, 'day').format('YYYY-MM-DD');
		}
		this.getLessonList();
	}

	//----------------------- 🤍 Watch 🤍 -----------------------//
	@Watch('$route')
	onRouterChange(value) {
		if (value?.name === 'report_lesson') {
			this.resetListAndPagingByCurrentQuery();
			this.getLessonList();
		}
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	flagCheck() {
		return FLAG_CHECK('CHECK_IN_CHECK_OUT');
	}

	async getLessonList() {
		if (this.stopLoad || this.isFetching) return;

		const requestId = this.listRequestId;
		this.isFetching = true;
		try {
			const q = this.$route.query;
			let shouldFetch = true;

			while (shouldFetch) {
				if (requestId !== this.listRequestId) return;

				const { data, date, stats, cancelled_stats } =
					await this.setup.listLessonReport(q, this.before);

				if (requestId !== this.listRequestId) return;

				if (data?.length > 0 || (data?.length === 0 && date)) {
					this.statsData[date] = {
						completed_count: stats.completed_count,
						incomplete_count: stats.incomplete_count,
						total: stats.total_count,
						cancelled: cancelled_stats.total_count,
						number_of_parent_read_count:
							stats.number_of_parent_read_count,
					};
					this.cancelData[date] = {
						completed_count: cancelled_stats.completed_count,
						incomplete_count: cancelled_stats.incomplete_count,
						total: cancelled_stats.total_count,
					};
					this.before = date;

					if (data?.length > 0) {
						this.LessonReports.push(...data);
						shouldFetch = false;
						continue;
					}

					const reachedRangeEnd =
						this.filter?.toDate &&
						dayjs(date).isBefore(dayjs(this.filter.toDate), 'day');
					if (reachedRangeEnd) {
						this.stopLoad = true;
						shouldFetch = false;
						continue;
					}
					continue;
				}

				this.stopLoad = true;
				shouldFetch = false;
			}
		} catch (e) {
			console.log(e);
		} finally {
			if (requestId === this.listRequestId) {
				this.isFetching = false;
				this.isLoading = false;
			}
		}
	}

	async loadFilterOptions() {
		if (this.filterOptionsLoaded || this.filterOptionsLoading) return;
		this.filterOptionsLoading = true;
		try {
			const [staffsOk, studentsOk] = await Promise.all([
				this.search(),
				this.fetchStudents(),
			]);
			this.filterOptionsLoaded = staffsOk && studentsOk;
		} finally {
			this.filterOptionsLoading = false;
		}
	}

	async search() {
		const res = await this.setup.getSimpleStaffs();
		this.staffs = res?.data || [];
		return !!res;
	}

	async fetchStudents() {
		const studentList = await this.setup.getSimpleStudents();
		this.students = studentList?.data || [];
		return !!studentList;
	}

	studentById(id) {
		return this.students.find((item) => item.id === id);
	}

	staffById(id) {
		return this.staffs.find((item) => item.id === id);
	}

	clean(obj) {
		for (let propName in obj) {
			if (
				obj[propName] === null ||
				obj[propName] === undefined ||
				obj[propName].length <= 0
			) {
				delete obj[propName];
			}
		}
		return obj;
	}

	filterSubmit(queryPa) {
		this.afterId = null;
		if (!queryPa) {
			this.date = dayjs(this.dateNow).format('DD/MM/YYYY');
			this.filter = null;
			this.$router.push('');
		} else {
			this.filter = {
				...this.filter,
				...queryPa,
			};
			this.clean(this.filter);
			const query = Object.keys(this.filter)
				.map((key) => `${key}=${this.filter[key]}`)
				.join('&');
			this.$router.push(`?${query}`);
		}
		this.sideOverShow = false;
	}

	// this gives an object with dates as keys
	groups(array) {
		return array.reduce((groups, item) => {
			const date = item.date;
			if (!groups[date]) {
				groups[date] = [];
			}
			groups[date].push(item);
			return groups;
		}, {});
	}

	showHide(date) {
		const index = this.isHides.indexOf(date);
		if (index !== -1) {
			this.isHides.splice(index, 1);
		} else {
			this.isHides.push(date);
		}
	}

	resetListAndPagingByCurrentQuery() {
		this.LessonReports = [];
		this.stopLoad = false;
		this.isFetching = false;
		this.listRequestId += 1;
		const queryDate = this.$route.query?.date;
		this.before = queryDate
			? dayjs(queryDate.toString()).add(1, 'day').format('YYYY-MM-DD')
			: '';
	}

	openDeleteConfirm(data) {
		this.dataProps = data;
		this.type = 'delete';
		this.modalIsOpen = true;
	}

	openSendData(data) {
		this.dataProps = data;
		this.type = 'send';
		this.modalIsOpen = true;
	}

	closeModal() {
		this.dataProps = null;

		this.modalIsOpen = false;
		this.type = 'null';
	}

	async success() {
		this.closeModal();
		this.resetListAndPagingByCurrentQuery();
		await this.getLessonList();
	}

	beforeDestroy() {
		this.isInfinityLoading = false;
	}

	async sendReport(item) {
		try {
			await $api.lessonReport.sendReport(item?.id);
			this.closeModal();
			await this.store.dispatch('setAlertMessage', {
				message: 'Báo cáo đã được gửi thành công đến phụ huynh.',
			});
			item.sent_at = new Date();
		} catch (err) {
			await this.store.dispatch('setAlertMessage', {
				message:
					err?.response?.data?.errors?.join('<br/>') ||
					'Đã có lỗi xảy ra. Vui lòng thử lại',
				type: 'danger',
			});
		}
	}
	async recoverReport(id) {
		try {
			const res = await $api.lessonReport.recoverReport(id);
			if (res.data) {
				await this.store.dispatch('setAlertMessage', {
					message: 'Khôi phục báo cáo thành công',
				});
				this.resetListAndPagingByCurrentQuery();
				await this.getLessonList();
			}
		} catch (err) {
			await this.store.dispatch('setAlertMessage', {
				message:
					err?.response?.data?.errors?.join('<br/>') ||
					'Đã có lỗi xảy ra. Vui lòng thử lại',
				type: 'danger',
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.teacher {
	&:hover {
		.teacher__name {
			text-decoration: underline;
			@apply text-yellow-500;
		}
	}
}
.grid-cols-2 {
	grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.submit {
	position: absolute;
	bottom: -10px;
	width: 16px;
	height: 16px;
	z-index: 1;
	background: white;
	border-radius: 50%;
	background: #a8c1de;
}

.__record__table {
	-webkit-overflow-scrolling: touch;
	overflow-x: auto;
	width: 100%;
}

.lesson-report-table {
	table-layout: auto;
	border-collapse: separate;
	border-spacing: 0;
}

.lesson-report-table th,
.lesson-report-table td {
	vertical-align: middle;
}

/* Tên HS / giáo viên: 1 dòng, hiện đủ */
.lesson-report-table .col-student,
.lesson-report-table .col-teacher {
	white-space: nowrap;
}

/* ≤1535: min-width cố định → hiện scroll ngang trên iPad/màn nhỏ */
@media (max-width: 1535px) {
	.lesson-report-table {
		width: auto;
		min-width: 1100px;
	}

	.lesson-report-table .col-stt {
		min-width: 48px;
		width: 48px;
	}
	.lesson-report-table .col-student {
		min-width: 180px;
	}
	.lesson-report-table .col-session {
		min-width: 90px;
		width: 90px;
	}
	.lesson-report-table .col-status {
		min-width: 70px;
		width: 70px;
	}
	.lesson-report-table .col-goal {
		min-width: 70px;
		width: 70px;
	}
	.lesson-report-table .col-emotion {
		min-width: 70px;
		width: 70px;
	}
	.lesson-report-table .col-album {
		min-width: 70px;
		width: 70px;
	}
	.lesson-report-table .col-participation {
		min-width: 150px;
		width: 150px;
	}
	.lesson-report-table .col-teacher {
		min-width: 140px;
	}
	.lesson-report-table .col-attendance {
		min-width: 120px;
		width: 120px;
	}
	.lesson-report-table .col-parent-read {
		min-width: 70px;
		width: 70px;
	}
	.lesson-report-table .col-action {
		min-width: 40px;
		width: 40px;
	}
}

/* >1535: full width, các cột khác dãn theo tỉ lệ */
@media (min-width: 1536px) {
	.lesson-report-table {
		width: 100%;
	}

	.lesson-report-table .col-stt {
		width: 4%;
	}
	.lesson-report-table .col-session {
		width: 10%;
	}
	.lesson-report-table .col-status {
		width: 8%;
	}
	.lesson-report-table .col-goal {
		width: 7%;
	}
	.lesson-report-table .col-emotion {
		width: 7%;
	}
	.lesson-report-table .col-album {
		width: 7%;
	}
	.lesson-report-table .col-participation {
		width: 14%;
	}
	.lesson-report-table .col-attendance {
		width: 12%;
	}
	.lesson-report-table .col-parent-read {
		width: 7%;
	}
	.lesson-report-table .col-action {
		width: 4%;
	}
}
</style>
